import React from "react";
import { Link, useNavigate, Outlet, Navigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import { ProtectedRoute } from "../../utility_components/routing_components/auth_routes";

import HeaderUser from "./components/layout_components/HeaderUser";

import Dashboard from "../main_portal/pages/Dashboard";
// import ExtendedProfile from "../main_portal/pages/ExtendedProfile";
import ExploreMissions from "../main_portal/pages/ExploreMissions";
import CashOutPage from "../main_portal/pages/CashOutPage";
import Wallets from "../main_portal/pages/Wallets"
import ContentOutline from "../main_portal/pages/ContentOutline";
import PageNotFound from "../../utility_components/routing_components/PageNotFound";
import ProfilePage from "./pages/ProfilePage";
import AccountSettings from "./pages/AccountSettings";
import Boosters from "./pages/Boosters";
import ExtendedProfile from "./pages/booster_pages/ExtendedProfile";
import Button from "./components/common_components/Button";
import WalletsPage from "./pages/WalletsPage";
import MissionsPage from "./components/missions_components/MissionsPage";
import MissionPage from "./components/mission_components/MissionPage";
import InterviewsPage from "./components/interview_components/InterviewsPage";
import PayoutsPage from "./components/payout_components/PayoutsPage";

function UserPortal(props) {
    return (
        <div className="user-app-container">
            <HeaderUser />
            <Background />
            <Routes>
                {/* These are the protected routes - requiring authorization */}
                <Route element={<ProtectedRoute />} >
                    <Route path='/profile' element={<ProfilePage />} />
                    <Route path='/wallets' element={<WalletsPage />} />
                    <Route path="/missions/"  >
                        <Route index element={<MissionsPage />} />
                        <Route path=':missionId/*' element={<MissionPage />} />
                    </Route>
                    <Route path='/interviews' element={<InterviewsPage />} />
                    <Route path='/payouts' element={<PayoutsPage />} />
                    <Route path='/account-settings' element={<AccountSettings />} />
                    <Route path='/boosters' element={<Boosters />} />
                    <Route path='/boosters/extended-profile' element={<ExtendedProfile />} />

                    {/* Some redirects for old routes */}
                    <Route path="/" element={<Navigate to="/missions" />} />
                    <Route path="/dashboard" element={<Navigate to="/missions" />} />
                </Route>


                {/* This is the default route - if no other route is matched, this will be rendered */}
                {/* For now, we redirect */}
                <Route path="*" element={<PageNotFound />} />
            </Routes>

        </div>

    )
}

function Background(props) {
    return (
        <div className="background-container">
            <div className="background-black"></div>
            <div className="background-gradient"></div>
        </div>
    );
}

export default UserPortal;